import { Baseline } from "lucide-react";
import { KEYS } from "platejs";
import { useEditorRef, useEditorSelector } from "platejs/react";
import { memo, useCallback, useEffect, useState } from "react";
import { RedoColorPicker } from "../../arbiter-components/color-picker/redo-color-picker";
import { cn } from "../../tailwind-utils";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";

export const ColorToolbarButton = memo(function ColorToolbarButton() {
  const editor = useEditorRef();
  const [open, setOpen] = useState(false);

  const selectionDefined = useEditorSelector(
    (editor) => !!editor.selection,
    [],
  );

  const color = useEditorSelector(
    (editor) => editor.api.mark(KEYS.color) as string,
    [],
  );

  const [selectedColor, setSelectedColor] = useState<string>("#000000");

  useEffect(() => {
    if (selectionDefined && color) {
      setSelectedColor(color);
    }
  }, [color, selectionDefined]);

  const handleChange = useCallback(
    (value: string) => {
      setSelectedColor(value);
      if (editor.selection) {
        editor.tf.select(editor.selection);
        editor.tf.focus();
        editor.tf.addMarks({ [KEYS.color]: value });
      }
    },
    [editor],
  );

  return (
    <Popover modal={false} onOpenChange={setOpen} open={open}>
      <PopoverTrigger asChild>
        <button
          className={cn(
            "inline-flex h-8 min-w-8 cursor-pointer items-center justify-center rounded-md px-1.5",
            "hover:bg-muted hover:text-muted-foreground",
          )}
          type="button"
        >
          <div className="flex flex-col items-center">
            <Baseline className="size-3.5" />
            <div
              className="h-0.5 w-3.5 rounded-full"
              style={{ backgroundColor: selectedColor }}
            />
          </div>
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="w-auto p-3"
        onInteractOutside={(e) => e.preventDefault()}
      >
        <RedoColorPicker onChange={handleChange} value={selectedColor} />
      </PopoverContent>
    </Popover>
  );
});
